

















































































import { DictServiceProxy } from "@/service-proxies/app-v2/system.service-proxies";
import { columns } from "./components/column";
import Add from "./components/create.vue";
import { ossList, ossDelete, ossEnable } from './api'
const service = new DictServiceProxy();
const options = {
  dictListApi: service.list.bind(service),
};

export default {
  components: { Add },
  computed: {
    columns() {
      return columns.map((item) => {
        return {
          ...item,
          title: this.$t(item.title),
        };
      }); // 表单配置
    },
    rowSelection() {
      const { selectedRowKeys }: any = this;
      return {
        selectedRowKeys,
        onChange: (selectedRowKeys: any) => {
          this.selectedRowKeys = selectedRowKeys;
        },
      };
    },
  },
  data() {
    return {
      dialog: false,
      ...options,
      dataSource: [], // 列表数据
      dictList: [], // 字典
      totalContent: 0, // 总数
      query: {
        size: 30,
        current: 1,
        ossCode: '',
        accessKey: '',
      },
      dictQuery: {
        code: "oss",
      },
      form: {
       accessKey: '',
       bucketName: '', //空间名
       category: '', // 分类
       endpoint: '', //资源地址
       ossCode: '', // 资源编号
       secretKey: '',
       remark: '',
      },
      selectedRowKeys: [],
      Rowkey: "", // 所选表单行
    };
  },
  created() {
    this.getDictList();
    this.getList();
  },
  methods: {
    handleCreate() {
      this.dialog = true;
      this.form = {
        accessKey: '',
        bucketName: '',
        category: this.dictList.length? this.dictList[0].dictKey : '',
        endpoint: '',
        ossCode: '',
        secretKey: '',
        remark: '',
      };
    },
    handleSearch() {
      this.query.current = 1;
      this.getList();
    },
    handleDelete() {
      // eslint-disable-next-line @typescript-eslint/no-this-alias
      let that = this;
      let ids = "";
      if (this.selectedRowKeys.length) {
        ids = this.selectedRowKeys.join(",");
      } else {
        ids = this.selectedRowKeys[0];
      }
      this.$confirm({
        content: "是否确定删除",
        onOk() {
          ossDelete({ids}).then(res=>{
            that.selectedRowKeys = [];
            that.$message.success(that.$t("delete_success"));
            that.getList();
          })
        },
      });
    },
    handleUpdate() {
      this.dialog = false;
      this.getList();
    },
    handleEdit(data) {
      let item = Object.assign({}, data);
      item.category = item.category.toString()
      this.form = item;
      item.disabled = false;
      this.dialog = true;
    },
    handleRead(data) {
      let item = Object.assign({}, data);
      item.category = item.category.toString()
      this.form = item;
      item.disabled = true;
      this.dialog = true;
    },
    handleEnable(data){
      // eslint-disable-next-line @typescript-eslint/no-this-alias
      let that = this;
      const {id,status}= data;
      let content= '是否确定启用这条配置';
      let message = '启用成功';
      //  if(status==1){
      //    content = '是否确定启用这条配置'
      //    message = '启用成功'
      //  }else{
      //    content = '是否确定关闭这条配置'
      //    message = '关闭成功'
      //  }
      this.$confirm({
        content: content,
        onOk() {
          ossEnable({id}).then(res=>{
             that.$message.success(message);
             that.getList();
          })
        },
      });
    },
    getList() {
      ossList(this.query).then(res=>{
        const {data} = res.data;
        if(data.records.length){
          this.dataSource = data.records;
          this.totalContent = data.total;
        }else{
          this.dataSource = [];
          this.totalContent = 0;
        }
      })
    },
    async getDictList(){
      const res = await this.dictListApi(this.dictQuery.code)
      const { children } = res.data[0];
      if (children) {
        this.dictList = children;
      }
    },
    pageIndexchange(current: any) {
      this.query.current = current;
      this.getList();
    },
    totalFanyi(number: any) {
      const total = this.$t("Total…items");
      return total.replace("{0}", number);
    },
  },
};
